export function getVersionAnchor(version) {
    return "version_" + version.replace(/\./g, "_");
}
